// components/Footer.jsx
import React from "react";
import {
  Box,
  Container,
  Typography,
  IconButton,
  Stack,
  Link,
} from "@mui/material";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { orange, purple, gray } from "../../theme/colors";
import { SiLeetcode } from "react-icons/si";

export default function Footer() {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: purple[800],
        color: gray[300],
        py: 3,
        mt: 8,
        borderTop: `1px solid ${purple[700]}`,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={{ xs: 2, sm: 0 }}
          sx={{ flexWrap: "wrap" }}
        >
          {/* Left: Name */}
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              color: orange[500],
              fontFamily: "Poppins, sans-serif",
            }}
          >
            © {new Date().getFullYear()} Pratik Shinde
          </Typography>

          {/* Middle: Links */}
          <Stack direction="row" spacing={3} sx={{ flexWrap: "wrap" }}>
            <Link
              underline="hover"
              onClick={() => handleScroll("aboutme")}
              sx={{ color: "inherit", scrollBehavior: "smooth" }}
            >
              About
            </Link>
            <Link
              onClick={() => handleScroll("projects")}
              underline="hover"
              sx={{ color: "inherit" }}
            >
              Projects
            </Link>
            <Link
              onClick={() => handleScroll("contact")}
              underline="hover"
              sx={{ color: "inherit" }}
            >
              Contact
            </Link>
          </Stack>

          {/* Right: Social */}
          <Stack direction="row" spacing={2}>
            <IconButton
              component="a"
              href="https://github.com/pratik7262"
              target="_blank"
              sx={{ color: gray[300], "&:hover": { color: orange[500] } }}
            >
              <FaGithub />
            </IconButton>
            <IconButton
              component="a"
              href="https://leetcode.com/u/pratik_7262/"
              target="_blank"
              sx={{ color: gray[300], "&:hover": { color: orange[500] } }}
            >
              <SiLeetcode />
            </IconButton>
            <IconButton
              component="a"
              href="https://linkedin.com/in/pratikshinde7262/"
              target="_blank"
              sx={{ color: gray[300], "&:hover": { color: orange[500] } }}
            >
              <FaLinkedin />
            </IconButton>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
